import { IOnInit } from "angular";
import { GridConfiguration } from "../../../records/views/recordGridView";
import {
  IContractType,
  vsServiceName as ContractServiceName,
} from "../../../Contract/shared/ContractService";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import { StateService } from "@uirouter/angularjs";

export class ContractGridComponentController implements IOnInit {
  static $inject = [ColumnDefinitionServiceName];
  dropdownOptions: IContractType[] = [];

  constructor(
    private readonly columnDefinitionService: ColumnDefinitionService
  ) {}

  readonly contractType!: IContractType;
  readonly gridConfiguration!: GridConfiguration;
  gridSelection: any[] = [];

  $onInit(): void {
    this.gridConfiguration.columns = [
      {
        colId: "select",
        headerName: "Select",
        template: `
          <input
            type="checkbox"
            ng-click="recordGridController.toggleRowSelection(data)"
            ng-checked="recordGridController.rowSelected(data)"
          />`,
        suppressSorting: true,
      },
      this.columnDefinitionService.getLinkColDef({
        colId: "info",
        headerName: "Info",
        iconClass: "fa fa-info-circle text-primary",
        stateExpression:
          "^.info.Machine({contractId: data.ContractInstanceId})",
      }),
      this.columnDefinitionService.getLinkColDef({
        colId: "edit",
        headerName: "Edit",
        iconClass: "fa fa-pencil text-primary",
        stateExpression:
          "main.contract.type.edit({contractId: data.ContractInstanceId, type: data.Type})",
        requiresPermission: "contractEdit",
      }),
      ...(this.gridConfiguration.columns ?? []),
    ];
  }
}
